import { render, staticRenderFns } from "./backForm.vue?vue&type=template&id=034cbca8&"
import script from "./backForm.vue?vue&type=script&lang=js&"
export * from "./backForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports